import { useState } from "react";
import { Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import BetterBreadcrumb from "src/components/Common/BetterBreadCrumb";
import { AddLogbookEntrySetupMaster } from "./AddLogbookEntrySetupMaster";
import { AddAcademicSetupMaster } from "./AddAcademicSetupMaster";

function SelectEntrySetupMaster() {
    const [activeTab, setActiveTab] = useState<string>('loogbook_setup');

    const toggleTab = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <div className='page-content'>
            <Container fluid>
                <BetterBreadcrumb
                    title={'Add Logbook Entry Setup Master'}
                    breadcrumbItem={[{ link: '/setup/logbook-entry-setup-master/', name: 'Logbook entry setup master list' }]}
                />
                <Card>
                    <CardBody>
                        <Nav tabs className="mb-3">
                            <NavItem>
                                <NavLink
                                    className={activeTab === 'loogbook_setup' ? 'active' : ''}
                                    onClick={() => toggleTab('loogbook_setup')}
                                >
                                    Logbook Subject Setup
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === 'academic_setup' ? 'active' : ''}
                                    onClick={() => toggleTab('academic_setup')}
                                >
                                    Academic Subject Setup
                                </NavLink>
                            </NavItem>
                            
                        </Nav>

                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="loogbook_setup">
                                <AddLogbookEntrySetupMaster />
                            </TabPane>
                            <TabPane tabId="academic_setup">
                                <AddAcademicSetupMaster />
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Container>
        </div>
    )
}

export default SelectEntrySetupMaster;
